import { render } from "./ParentForm.vue?vue&type=template&id=7ba608b0"
import script from "./ParentForm.vue?vue&type=script&lang=js"
export * from "./ParentForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__